import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Status } from './status';
import { ProtectedRoute } from '../../shared/auth';

function statusRoute(routeProps: RouteComponentProps) {
  return (
    <ProtectedRoute path={`${routeProps.match.url}/status`}>
      <Status />
    </ProtectedRoute>
  );
}

export { statusRoute };
